import { SET_IS_EPOS_NOW } from "../reducers/isEposNow";


export function setIsEposNow(isEposNow: boolean) {
    return {
        type: SET_IS_EPOS_NOW,
        payload: isEposNow
    }
}